import React, { useState, useEffect } from 'react';
import useStyles from './styles';
import { get } from 'global/lib/lodash';
import { getColorFromScore } from 'global/styles';
import useRetrieveData from 'global/hooks/useRetrieveData';
import { filterData } from '../AssessmentScore';
import { useLoaded } from 'global/hooks/useLoaded';
import { PScoreIncludes } from '../Assessment/ReportAssessment';

const TARGET_COLORS = { higher: '#2196F3', lower: '#f44336' };

const ScoreRow = (props) => {
  const { title, score, displayScore, goalScore, scorecardConfig } = props;
  const classes = useStyles();

  let val = parseFloat(typeof score === 'string' ? score.replace('%', '') : score);
  let goalVal = goalScore != null ? parseFloat(typeof goalScore === 'string' ? goalScore.replace('%', '') : goalScore) : null;

  const hasGoal = goalVal != null && !isNaN(goalVal) && !isNaN(val);
  const diff = hasGoal ? goalVal - val : 0;
  const diffColor = diff >= 0 ? TARGET_COLORS.higher : TARGET_COLORS.lower;

  const formatDiff = (d) => {
    const displayPct = get(scorecardConfig, 'displayPercentage');
    const maxScore = get(scorecardConfig, 'maxScore', 100);
    const minScore = get(scorecardConfig, 'minScore', 0);
    let disp = displayPct ? d : d * ((maxScore - minScore) / 100);
    disp = parseFloat(disp.toFixed(2));
    const prefix = disp >= 0 ? '+' : '';
    return `${prefix}${disp}`;
  };

  return (
    <div className={classes.scoreRow}>
      <div className={classes.scoreTitle}>{title}</div>
      <div className={classes.box}>
        <div className={classes.boxBg} style={{ width: `${val}%`, backgroundColor: getColorFromScore(val) }} />
        {hasGoal && (
          <div className={classes.blackBar} style={{ left: `calc(2px + ${val}%)` }} />
        )}
        {hasGoal && diff !== 0 && (
          <div
            className={classes.targetBar}
            style={{
              left: `calc(2px + ${Math.min(val, goalVal)}%)`,
              width: `${Math.abs(diff)}%`,
              backgroundColor: diffColor,
            }}
          />
        )}
      </div>
      <div className={classes.scoreValue}>
        {displayScore}
        {hasGoal && (
          <span className={classes.targetDiff} style={{ color: diffColor }}>
            {formatDiff(diff)}
          </span>
        )}
      </div>
    </div>
  );
};

const ScoreCard = (props) => {
  const { assessment, scorecard, scores, scorecardIndex } = props;
  const [systems, setsystems] = useState([]);
  const classes = useStyles();

  const assessment_id = get(assessment, 'data.id', null);
  const scorecardConfig = get(scorecard, 'config');

  const { data, loading } = scores || {};

  const loadProcessed = async () => {
    if (!loading) {
      const s = (data && data[scorecard.id]) ? data[scorecard.id].filter((d) => d.depth < 2) : [];
      setsystems(s);
    }
  };

  useEffect(() => {
    loadProcessed();
  }, [data, loading]);

  return (
    <div className={classes.scorecardWrap}>
      <div className={classes.scorecardTitle}>{get(scorecard, 'name')}</div>

      <ScoreRow title={`Overall`} score={get(systems, '0.value')} displayScore={get(systems, '0.displayScore')} goalScore={get(systems, '0.goal.value')} scorecardConfig={scorecardConfig} />

      {systems.filter((d) => d.depth === 1 && d.value !== null).map((sc, i) => (
        <ScoreRow key={i} title={sc.name} displayScore={sc.displayScore || sc.value} score={sc.value || sc.displayScore} goalScore={get(sc, 'goal.value')} scorecardConfig={scorecardConfig} />
      ))}
    </div>
  );
};

export default (props) => {
  const { assessment, canShowScores, scores } = props;
  const classes = useStyles();

  const cards = get(assessment, 'data.scorecards', []);

  useLoaded(props, [!cards]);

  return !canShowScores ? null : (
    <div className={classes.container}>
      <div className={classes.title}>Scorecard Summary</div>

      {cards.map((card, i) => (
        <ScoreCard key={i} scorecard={card} scores={scores} scorecardIndex={i} assessment={assessment} />
      ))}
    </div>
  );
};
